import React from "react";

const LogoOrTitle = ({
  logo,
  title,
  className,
  logoClassName,
  titleClassName,
}) => {
  return logo ? (
    <img 
      className={`${className} ${logoClassName}`} 
      src={logo} 
      alt={title}
    />
  ) : (
    <h2 className={`${className} ${titleClassName}`}>{title}</h2>
  );
};

export default LogoOrTitle;
